export default __webpack_public_path__ + "static/media/meat-lovers-choice.9f78c65e.png";